module.exports = __webpack_public_path__ + "static/media/autoestima.2ca859ca.svg";